"use client"

import { chakra } from "@chakra-ui/react"
import recipe from "./recipe"

export const Button = chakra("button", recipe);
export default Button
